import { FC, MutableRefObject, createContext, useRef } from "react";
import { FreeFortuneContent } from "shared/types";

export interface FreeFortuneContextValue {
  modal: MutableRefObject<any>;
  content: FreeFortuneContent;
}

export const FreeFortuneContext = createContext<FreeFortuneContextValue>({
  modal: null,
  content: null,
});

interface Props {
  content?: FreeFortuneContent;
}

export const FreeFortuneProvider: FC<Props> = ({ content, children }) => {
  const modal = useRef(null);

  return (
    <FreeFortuneContext.Provider value={{ modal, content }}>
      {children}
    </FreeFortuneContext.Provider>
  );
};
